// extracted by mini-css-extract-plugin
module.exports = {"routesList":"RoutesList_routesList__95TDE","routeRow":"RoutesList_routeRow__3n1cz","checkbox":"RoutesList_checkbox__2X6MO"};